import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
    Bundle,
    BundleType,
    Release,
    SiteCredentials,
    SiteDeploymentType,
} from '@myrtls/api-interfaces';

export const getCredentialsRequestAction = createAction(
    '[Deployment] Get Credentials Request',
);

export const getCredentialsSuccessAction = createAction(
    '[Deployment] Get Credentials Success',
    props<{ credentials: SiteCredentials }>(),
);

export const getCredentialsFailureAction = createAction(
    '[Deployment] Get Credentials Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const deploySiteRequestAction = createAction(
    '[Deployment] Deploy Site Request',
    props<{ deploymentType: SiteDeploymentType }>(),
);

export const deploySiteSuccessAction = createAction(
    '[Deployment] Deploy Site Success',
);

export const deploySiteFailureAction = createAction(
    '[Deployment] Deploy Site Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const getSiteDeploymentBundlesAction = createAction(
    '[Deployment] Get Site Deployment Bundles',
    props<{ bundleType: BundleType }>(),
);

export const getSiteDeploymentBundlesSuccessAction = createAction(
    '[Deployment] Get Site Deployment Bundles Success',
    props<{ bundles: Bundle[]; bundleType: BundleType }>(),
);

export const getSiteDeploymentBundlesFailureAction = createAction(
    '[Deployment] Get Site Deployment Bundles Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const createSiteDeploymentBundleAction = createAction(
    '[Deployment] Create Site Deployment Bundle',
    props<{ bundleType: BundleType; version: string }>(),
);

export const createSiteDeploymentBundleSuccessAction = createAction(
    '[Deployment] Create Site Deployment Bundle Success',
    props<{ bundle: Bundle }>(),
);

export const createSiteDeploymentBundleFailureAction = createAction(
    '[Deployment] Create Site Deployment Bundle Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const downloadSiteDeploymentAction = createAction(
    '[Deployment] Site Deployment Download',
    props<{ uuid: string; bundleType: BundleType }>(),
);

export const downloadSiteDeploymentSuccessAction = createAction(
    '[Deployment] Site Deployment Download Success',
);

export const downloadSiteDeploymentFailureAction = createAction(
    '[Deployment] Site Deployment Download Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const startPoolingSiteDeploymentBundlesAction = createAction(
    '[Deployment] Start Pooling Site Deployment Bundles',
    props<{ intervalTime: number; bundleType: BundleType }>(),
);

export const stopPoolingSiteDeploymentBundlesAction = createAction(
    '[Deployment] Stop Pooling Site Deployment Bundles',
);

export const getSiteReleasesAction = createAction('[Deployment] Get Site Releases');

export const getSiteReleasesSuccessAction = createAction(
    '[Deployment] Get Site Releases Success',
    props<{ releases: Release[] }>(),
);

export const getSiteReleasesFailureAction = createAction(
    '[Deployment] Get Site Releases Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const getVersionAction = createAction('[Deployment] Get Version');

export const getVersionSuccessAction = createAction(
    '[Deployment] Get Version Success',
    props<{ version: string }>(),
);

export const getVersionFailureAction = createAction(
    '[Deployment] Get Version Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const createSiteTemplatesRequestAction = createAction(
    '[Deployment] Create Site Templates Request',
);

export const createSiteTemplatesSuccessAction = createAction(
    '[Deployment] Create Site Templates Success',
);

export const createSiteTemplatesFailureAction = createAction(
    '[Deployment] Create Site Templates Failure',
    props<{ error: HttpErrorResponse }>(),
);
